const white = {
  primary: '#FFF',
  hover: '#F8FAFC',
  active: '#F2F5F7',
};

const black = {
  primary: '#333333',
};

const gray = {
  hover: '#D9DDE3',
  active: '#CBCFD4',
  primary: '#E5EAF0',
};

const graydark = {
  hover: '#9EA7B0',
  active: '#858C94',
  primary: '#7D848D',
};

const greendark = {
  shadow8: '#51818114',
  shadow14: '#51818124',
  shadow20: '#00484233',
  shadow26: '#51818142',
};

export const blue = {
  hover: '#0186BF',
  active: '#0186BF',
  primary: '#0C7BAA',
  secondary: {
    hover: '#0186BF',
    active: '#0186BF',
    primary: '#0C7BAA',
  },
};

const red = {
  secondary: { hover: '#FADDDD', active: '#F1C9C8', primary: '#FFEFEF' },
  primary: {
    hover: '#E55653',
    active: '#D14A47',
    primary: '#FD6460',
  },
};

export const colors = {
  red,
  blue,
  gray,
  white,
  black,
  graydark,
  greendark,
};
